import { render, staticRenderFns } from "./Main-layout.vue?vue&type=template&id=814a5280&"
import script from "./Main-layout.vue?vue&type=script&lang=js&"
export * from "./Main-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports